import { Checkbox } from "@/components/Base/Checkbox";
import { FormLabel } from "@/components/Base/Form";
import { VEHICLE_FIELDS, VehicleFieldKey } from "@/types/v2";

type VehicleFieldSelectorProps = {
  selectedFields: VehicleFieldKey[];
  onChange: (fields: VehicleFieldKey[]) => void;
  disabled?: boolean;
};

export const VehicleFieldSelector = ({
  selectedFields,
  onChange,
  disabled,
}: VehicleFieldSelectorProps) => {
  const handleToggle = (field: VehicleFieldKey) => {
    const newFields = selectedFields.includes(field)
      ? selectedFields.filter((f) => f !== field)
      : [...selectedFields, field];
    onChange(newFields);
  };

  const getFieldLabel = (field: VehicleFieldKey): string => {
    const labels: Record<VehicleFieldKey, string> = {
      year: "Year",
      make: "Make",
      model: "Model",
    };
    return labels[field];
  };

  return (
    <div className="space-y-4">
      <FormLabel>Required Vehicle Fields</FormLabel>
      <div className="flex flex-col gap-2">
        {VEHICLE_FIELDS.map((field) => (
          <div key={field} className="flex items-center space-x-2">
            <Checkbox
              id={`vehicle-field-${field}`}
              checked={selectedFields.includes(field)}
              onCheckedChange={() => handleToggle(field)}
              disabled={disabled}
            />
            <label
              htmlFor={`vehicle-field-${field}`}
              className="text-sm font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70"
            >
              {getFieldLabel(field)}
            </label>
          </div>
        ))}
      </div>
    </div>
  );
};
